import request from '@/utils/request'

const approvalManage = {
  name: 'approvalManage',
  state: {
    isDetailLoading: false,
    approvalDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_APPROVAL_DETAIL_LOADING: (state, data) => {
      state.isDetailLoading = data
    },
    SET_MODULES_APPROVAL_DETAIL_DATA: (state, data) => {
      state.approvalDetailData = data
    }
  },

  actions: {
    // 获取详情数据
    queryApprovalDetailData({ commit }, id) {
      commit('SET_IS_MODULES_APPROVAL_DETAIL_LOADING', true)
      commit('SET_MODULES_APPROVAL_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/approve/approveDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_APPROVAL_DETAIL_LOADING', false)
          commit('SET_MODULES_APPROVAL_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_APPROVAL_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    // 重置预警记录详情数据
    resetApprovalDetailData({ commit }) {
      commit('SET_MODULES_APPROVAL_DETAIL_DATA', {})
    },
    // 设置预警记录详情数据
    setApprovalDetailData({ commit }, data) {
      commit('SET_MODULES_APPROVAL_DETAIL_DATA', data)
    }
  }
}

export default approvalManage
